import _regeneratorRuntime from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { simplify } from 'wikidata-sdk';
import { parse as fetch, parseAsync as fetchAsync } from './api';
import { parse as getUrls } from './id';
var SIMPLIFY_OPTS = {
  keepQualifiers: true,
  timeConverter: 'simple-day'
};
var FETCH_PLACE = {
  P17: null
};
var FETCH_PUBLISHER = {
  P740: FETCH_PLACE,
  P159: FETCH_PLACE
};
var FETCH_ADDITIONAL = {
  P50: null,
  P57: null,
  P86: null,
  P98: null,
  P110: null,
  P655: null,
  P1817: null,
  P921: {
    P50: null
  },
  P407: null,
  P364: null,
  P123: FETCH_PUBLISHER,
  P629: {
    P50: null,
    P123: FETCH_PUBLISHER
  },
  P437: null,
  P186: null,
  P179: {
    P98: null
  },
  P1433: {
    P4745: {
      P276: FETCH_PLACE
    }
  },
  P361: {
    P50: null
  }
};

function flat(array, part) {
  array.push.apply(array, _toConsumableArray(part));
  return array;
}

function collectAdditionalIds(entity, needed) {
  if (!needed) {
    return [];
  }

  entity._needed = Object.assign(entity._needed || {}, needed);
  return Object.keys(entity.claims).filter(function (prop) {
    return prop in needed;
  }).map(function (prop) {
    return entity.claims[prop].map(function (_ref) {
      var value = _ref.value;
      return value.id || value;
    });
  }).reduce(flat, []);
}

function completeResponse(entities, old) {
  if (!old) {
    var allIds = [];

    for (var _id in entities) {
      var _ids = collectAdditionalIds(entities[_id], FETCH_ADDITIONAL);

      var _iterator = _createForOfIteratorHelper(_ids),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _id2 = _step.value;

          if (!allIds.includes(_id2)) {
            allIds.push(_id2);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return allIds;
  }

  var ids = [];

  var _iterator2 = _createForOfIteratorHelper(old),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var id = _step2.value;
      var entity = entities[id];

      if (!entity._needed) {
        continue;
      }

      for (var prop in entity.claims) {
        if (prop in entity._needed) {
          var _iterator3 = _createForOfIteratorHelper(entity.claims[prop]),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var claim = _step3.value;

              if (claim.value && claim.value.id) {
                continue;
              }

              claim.value = entities[claim.value];
              ids.push.apply(ids, _toConsumableArray(collectAdditionalIds(claim.value, entity._needed[prop])));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }

      delete entity._needed;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return ids;
}

function simplifyEntities(entities) {
  return simplify.entities(entities, SIMPLIFY_OPTS);
}

function initLoopState(entities, cache) {
  return {
    needed: completeResponse(cache),
    incomplete: Object.keys(entities)
  };
}

function filterIdsAndGetUrls(needed, cache) {
  var shouldFetch = needed.filter(function (id, i) {
    return !(id in cache) && needed.indexOf(id) === i;
  });
  return getUrls(shouldFetch);
}

function addItemsToCache(response, cache) {
  var _JSON$parse = JSON.parse(response),
      entities = _JSON$parse.entities;

  Object.assign(cache, simplifyEntities(entities));
}

function updateLoopState(state, cache) {
  return {
    needed: completeResponse(cache, state.incomplete),
    incomplete: state.needed
  };
}

function finalizeItems(entities, cache) {
  return Object.keys(entities).map(function (id) {
    return cache[id];
  });
}

export function fillCache(entities) {
  var cache = simplifyEntities(entities);
  var state = initLoopState(entities, cache);

  while (state.needed.length) {
    var urls = filterIdsAndGetUrls(state.needed, cache);
    urls.map(function (url) {
      return addItemsToCache(fetch(url), cache);
    });
    state = updateLoopState(state, cache);
  }

  return cache;
}
export function parse(entities) {
  var cache = fillCache(entities);
  return finalizeItems(entities, cache);
}
export function fillCacheAsync(_x) {
  return _fillCacheAsync.apply(this, arguments);
}

function _fillCacheAsync() {
  _fillCacheAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entities) {
    var cache, state, urls;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cache = simplifyEntities(entities);
            state = initLoopState(entities, cache);

          case 2:
            if (!state.needed.length) {
              _context2.next = 9;
              break;
            }

            urls = filterIdsAndGetUrls(state.needed, cache);
            _context2.next = 6;
            return Promise.all(urls.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.t0 = addItemsToCache;
                        _context.next = 3;
                        return fetchAsync(url);

                      case 3:
                        _context.t1 = _context.sent;
                        _context.t2 = cache;
                        return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2));

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 6:
            state = updateLoopState(state, cache);
            _context2.next = 2;
            break;

          case 9:
            return _context2.abrupt("return", cache);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fillCacheAsync.apply(this, arguments);
}

export function parseAsync(_x2) {
  return _parseAsync.apply(this, arguments);
}

function _parseAsync() {
  _parseAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(entities) {
    var cache;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fillCacheAsync(entities);

          case 2:
            cache = _context3.sent;
            return _context3.abrupt("return", finalizeItems(entities, cache));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _parseAsync.apply(this, arguments);
}